/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_screenshot_view_scraper_api_v1_spider_tasks__task_id__screenshot__patch } from '../models/Body_upload_screenshot_view_scraper_api_v1_spider_tasks__task_id__screenshot__patch';
import type { BulkDeleteRequest } from '../models/BulkDeleteRequest';
import type { CampaignsListResponse } from '../models/CampaignsListResponse';
import { FileTypes } from '../models/FileTypes';
import type { FireCrawlParsePayload } from '../models/FireCrawlParsePayload';
import type { FireCrawlWebhookPayload } from '../models/FireCrawlWebhookPayload';
import type { PublicParsePayload } from '../models/PublicParsePayload';
import type { ResultsSpiderKnowledgeResponse } from '../models/ResultsSpiderKnowledgeResponse';
import type { TasksDetails } from '../models/TasksDetails';
import type { TasksResponse } from '../models/TasksResponse';
import type { TaskStatus } from '../models/TaskStatus';
import type { TaskStatusMetrics } from '../models/TaskStatusMetrics';
import type { TaskStatusResponse } from '../models/TaskStatusResponse';
import type { TreeResultSpiderResponse } from '../models/TreeResultSpiderResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpiderService {
  /**
   * Public Parse View
   * @param requestBody
   * @returns TasksResponse Successful Response
   * @throws ApiError
   */
  public static publicParseViewScraperApiV1SpiderPublicParsePost(
    requestBody: PublicParsePayload
  ): CancelablePromise<TasksResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/public/parse/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Firecrawl Parse View
   * @param requestBody
   * @returns TasksResponse Successful Response
   * @throws ApiError
   */
  public static firecrawlParseViewScraperApiV1SpiderFirecrawlParsePost(
    requestBody: FireCrawlParsePayload
  ): CancelablePromise<TasksResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/firecrawl/parse/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Firecrawl Webhook
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static firecrawlWebhookScraperApiV1SpiderFirecrawlWebhookPost(
    requestBody: FireCrawlWebhookPayload
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/firecrawl/webhook/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Cancel Task View
   * @param taskId
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns void
   * @throws ApiError
   */
  public static cancelTaskViewScraperApiV1SpiderTasksTaskIdCancelDelete(
    taskId: string,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/scraper/api/v1/spider/tasks/{task_id}/cancel/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Task Status View
   * @param taskId
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns TaskStatusResponse Successful Response
   * @throws ApiError
   */
  public static getTaskStatusViewScraperApiV1SpiderTasksTaskIdStatusGet(
    taskId: string,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<TaskStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/status/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Retry Task View
   * Endpoint to retry a failed Celery task.
   * @param taskId
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns TaskStatusResponse Successful Response
   * @throws ApiError
   */
  public static retryTaskViewScraperApiV1SpiderTasksTaskIdRetryPost(
    taskId: string,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<TaskStatusResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/tasks/{task_id}/retry/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Tasks View
   * @param page
   * @param limit
   * @param url
   * @param campaignName
   * @param status
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns TasksDetails Successful Response
   * @throws ApiError
   */
  public static getTasksViewScraperApiV1SpiderTasksGet(
    page: number = 1,
    limit: number = 10,
    url?: string | null,
    campaignName?: string | null,
    status?: TaskStatus | null,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<TasksDetails> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        page: page,
        limit: limit,
        url: url,
        campaign_name: campaignName,
        status: status,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Export Tasks View
   * @param taskIds List of task IDs to export
   * @param url Search tasks by URL
   * @param campaignName Search tasks by campaign name
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns any Successful Response
   * @throws ApiError
   */
  public static exportTasksViewScraperApiV1SpiderTasksExportGet(
    taskIds?: Array<string> | null,
    url?: string | null,
    campaignName?: string | null,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/export',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        task_ids: taskIds,
        url: url,
        campaign_name: campaignName,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Parsed Content View
   * @param taskId
   * @param page
   * @param limit
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns ResultsSpiderKnowledgeResponse Successful Response
   * @throws ApiError
   */
  public static getParsedContentViewScraperApiV1SpiderTasksTaskIdResultGet(
    taskId: string,
    page: number = 1,
    limit: number = 50,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<ResultsSpiderKnowledgeResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/result/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        page: page,
        limit: limit,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Download Parsed Data View
   * @param taskId
   * @param fileType Type of file to download
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns any Download parsed data as a ZIP file
   * @throws ApiError
   */
  public static downloadParsedDataViewScraperApiV1SpiderTasksTaskIdResultDownloadGet(
    taskId: string,
    fileType: FileTypes = FileTypes.ZIP,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/result/download/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        file_type: fileType ?? FileTypes.ZIP,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Result Tree View
   * @param taskId
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns TreeResultSpiderResponse Successful Response
   * @throws ApiError
   */
  public static getResultTreeViewScraperApiV1SpiderTasksTaskIdResultTreeGet(
    taskId: string,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<TreeResultSpiderResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/result/tree/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Tasks View
   * @param requestBody
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns void
   * @throws ApiError
   */
  public static removeTasksViewScraperApiV1SpiderTasksRemoveDelete(
    requestBody: BulkDeleteRequest,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/scraper/api/v1/spider/tasks/remove/',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Campaigns List View
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns CampaignsListResponse Successful Response
   * @throws ApiError
   */
  public static campaignsListViewScraperApiV1SpiderCampaignsGet(
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<CampaignsListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/campaigns/',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Refresh Demo View
   * @param taskIds
   * @param campaignName
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns void
   * @throws ApiError
   */
  public static refreshDemoViewScraperApiV1SpiderTasksRefreshDemoPatch(
    taskIds?: Array<string> | null,
    campaignName?: string | null,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/scraper/api/v1/spider/tasks/refresh-demo/',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        task_ids: taskIds,
        campaign_name: campaignName,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Screenshot View
   * @param taskId
   * @param formData
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns void
   * @throws ApiError
   */
  public static uploadScreenshotViewScraperApiV1SpiderTasksTaskIdScreenshotPatch(
    taskId: string,
    formData: Body_upload_screenshot_view_scraper_api_v1_spider_tasks__task_id__screenshot__patch,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/scraper/api/v1/spider/tasks/{task_id}/screenshot/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Status Metrics View
   * @param url
   * @param campaignName
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns TaskStatusMetrics Successful Response
   * @throws ApiError
   */
  public static statusMetricsViewScraperApiV1SpiderMetricsStatusBreakdownGet(
    url?: string | null,
    campaignName?: string | null,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<TaskStatusMetrics> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/metrics/status-breakdown/',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        url: url,
        campaign_name: campaignName,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
